/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */



import {NgModule} from '@angular/core';
import {ClrSyntaxHighlightModule} from './syntax-highlight/syntax-highlight.module';
export class ClrCodeModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{exports: [ClrSyntaxHighlightModule]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrCodeModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrCodeModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrCodeModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
